<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             :ok-text="$t('common.yes')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>
      <span v-t="{
              path: 'project.signing-checklist.list.SigningChecklistVoidedToDraftStepDialog.title',
              plural: count,
            }" />
    </template>
    <template #body>
      <span v-t="{
              path: 'project.signing-checklist.list.SigningChecklistVoidedToDraftStepDialog.body',
              plural: count,
            }" />
    </template>
  </AppDialog>
</template>

<script>
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistVoidedToDraftStepDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
